import React, { useState, useEffect } from "react";
import styled from "styled-components";

/**
 * @component MoleculePopupCalender
 * @description 날짜 선택용 캘린더 드롭다운 컴포넌트
 */
const CalendarOverlay = styled.div`
  display: inline-flex;
  flex-direction: column;
  width: ${props => props.width}px;
  background: white;
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  padding: 16px;
  z-index: 1000;
  gap: 12px;

`;

// 상단 월 네비게이션
const Nav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const MonthLabel = styled.span`
  font-size: 19px;
  font-weight: 600;
`;
const NavButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
`;

// 요일 헤더
const WeekDays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  font-weight: 500;
  color: #666;
`;

// 날짜 그리드
const DatesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  gap: 4px;
`;
const DateCell = styled.button`
  height: 24px;
  padding: 8px 0;
  border-radius: 6px;
  background: ${({ selected }) => (selected ? "#256EF4" : "transparent")};
  color: ${({ selected }) => (selected ? "white" : "#323232")};
  border: none;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #e5e5ea;
  }
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
`;

const CompleteButton = styled.button`
  width: 283px;
  height: 36px;
  background: ${props => props.disabled ? '#E5E5EA' : '#256EF4'};
  border: none;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const CompletText = styled.span`
  color: white;
  font-size: 17px;
  font-weight: 500;
  line-height: 25.5px;
`;

export default function MoleculePopupCalender({
  month,            // Date 객체: 현재 보고 있는 달
  onPrevMonth,      // () => void
  onNextMonth,      // () => void
  selectedDate,     // Date 객체: 선택된 날짜
  onSelectDate,     // (day: Date) => void
  width = 305,      // number: 캘린더 너비 (기본값: 305px)
  onConfirm,        // () => void: 확인 버튼 클릭 시 실행될 함수
}) {
  const [hasDateChanged, setHasDateChanged] = useState(false);
  // 1. 현재 달의 1일, 마지막일, 요일 계산
  const year = month.getFullYear();
  const mon = month.getMonth();
  const firstDay = new Date(year, mon, 1).getDay(); // 0(일)~6(토)
  const daysInMonth = new Date(year, mon + 1, 0).getDate();

  // 2. 달력에 채워질 숫자 배열 생성
  const cells = [];
  for (let i = 0; i < firstDay; i++) {
    cells.push(null);
  }
  for (let d = 1; d <= daysInMonth; d++) {
    cells.push(new Date(year, mon, d));
  }

  const weekLabels = ["일", "월", "화", "수", "목", "금", "토"];

  return (
    <CalendarOverlay width={width}>
      <Nav>
        <NavButton onClick={onPrevMonth}>‹</NavButton>
        <MonthLabel>{year}년 {mon + 1}월</MonthLabel>
        <NavButton onClick={onNextMonth}>›</NavButton>
      </Nav>
      <WeekDays>
        {weekLabels.map(w => <span key={w}>{w}</span>)}
      </WeekDays>
      <DatesGrid>
        {cells.map((dt, i) =>
          dt ? (
            <DateCell
              key={i}
              selected={
                selectedDate &&
                dt.toDateString() === selectedDate.toDateString()
              }
              onClick={() => {
                onSelectDate(dt);
                setHasDateChanged(true);
              }}
            >
              {dt.getDate()}
            </DateCell>
          ) : (
            <div key={i} />
          )
        )}
      </DatesGrid>
             <Footer>
         <CompleteButton 
           disabled={!hasDateChanged} 
           onClick={hasDateChanged ? onConfirm : undefined}
         >
           <CompletText>확인</CompletText>
         </CompleteButton>
       </Footer>
    </CalendarOverlay>
  );
}
